import { render, staticRenderFns } from "./LocalAudioControlButton.vue?vue&type=template&id=eba8020a&scoped=true"
import script from "./LocalAudioControlButton.vue?vue&type=script&lang=js"
export * from "./LocalAudioControlButton.vue?vue&type=script&lang=js"
import style0 from "./LocalAudioControlButton.vue?vue&type=style&index=0&id=eba8020a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba8020a",
  null
  
)

export default component.exports